export enum FeriasEmGradeEnum {
  SITUACAO_RASCUNHO = -1,
  SITUACAO_PENDENTE = 0,
  SITUACAO_APROVADO = 1,
  SITUACAO_REPROVADO = 2,
}
